import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

// The standalone checkout page has been removed — purchases now complete in the
// "Confirm your purchase" modal on the listing page. Any stale link redirects there.
export default function Checkout() {
  const { listingId } = useParams();
  const navigate = useNavigate();
  useEffect(() => { navigate(listingId ? `/listing/${listingId}` : "/", { replace: true }); }, [listingId, navigate]);
  return null;
}
